import PageBlock from '@/components/PageBlock';
import classNames from 'classnames';

import styles from './counts-2.module.css';

const Counts2 = ({ items, className, contentClassName, descriptionClassName, variant = 'white' }) => {
  if (!items) return null;

  return (
    <PageBlock variant={variant} className={classNames(styles.root, className)}>
      <div className={classNames(styles.content, contentClassName)}>
        {items.map(({ title, description }, index) => (
          <div className={styles.item} key={index}>
            <div className={styles.title} dangerouslySetInnerHTML={{ __html: title }} />
            <div className={classNames(styles.description, descriptionClassName)}>{description}</div>
          </div>
        ))}
      </div>
    </PageBlock>
  );
};

export default Counts2;
